import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import type { ProductOrderConfig } from '../../../types/pricing-feature.types';

const defaultProductOrderConfig: ProductOrderConfig = {
  skipRedirectOnSuccess: false,
};
type KProductOrderConfig = keyof ProductOrderConfig;

@Injectable()
export class ProductOrderConfigService {
  private readonly route = inject(ActivatedRoute);

  public readonly setup: ProductOrderConfig;

  constructor() {
    const route = this.route;

    const params = route.snapshot.queryParams || {};
    const configKeys = Object.keys(defaultProductOrderConfig);

    const config = { ...defaultProductOrderConfig };

    configKeys.forEach((key: KProductOrderConfig) => {
      if (params[key] === undefined) return;
      if (typeof config[key] === 'boolean') {
        config[key] = params[key] === 'true';
      }
    });

    this.setup = config;
  }
}
